<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Actieve Werknemers</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
		</v-card-title>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" @click="setEmployeeCohort()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Add EmployeeCohort
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
			<template v-slot:item.tbl_employee.osbod_email="{ item }">
				<span v-if="hasOsbodEmail(item)">{{ osbodEmail(item) }}</span>
				<v-tooltip v-else bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							small
							depressed
							color="primary"
							v-bind="attrs"
							v-on="on"
							:disabled="provisioningId === item.id"
							:loading="provisioningId === item.id"
							@click="openProvision(item)"
						>
							OSBOD e-mail aanmaken
						</v-btn>
					</template>
					<span>Create OSBOD Email</span>
				</v-tooltip>
			</template>
		</v-data-table>

		<v-dialog v-model="confirmDialog" max-width="520">
			<v-card>
				<v-card-title>OSBOD e-mail aanmaken?</v-card-title>
				<v-card-text v-if="selected">
					<p class="body-2">
						Er wordt een OSBOD e-mailaccount aangemaakt voor
						<strong>{{ employeeName(selected) }}</strong>
						met een Office 365 A1 for Faculty-licentie.
					</p>
					<p class="body-2">
						<span v-if="previewLoading">
							<v-progress-circular indeterminate size="14" width="2" class="mr-2"></v-progress-circular>
							Beschikbaarheid van de OSBOD e-mail wordt gecontroleerd...
						</span>
						<span v-else-if="previewError" class="error--text">{{ previewError }}</span>
						<span v-else-if="previewAlreadyExists">
							Er bestaat al een Microsoft-account voor deze werknemer:
							<strong>{{ previewEmail }}</strong>. Dit account wordt gekoppeld.
						</span>
						<span v-else>
							De OSBOD e-mail wordt <strong>{{ previewEmail }}</strong>
							(gecontroleerd en beschikbaar).
						</span>
					</p>
					<p class="body-2 mb-0">
						De inloggegevens worden verstuurd naar
						<strong>{{ personalEmail(selected) || "het persoonlijke e-mailadres (indien aanwezig)" }}</strong>.
					</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text :disabled="!!provisioningId" @click="confirmDialog = false">Annuleren</v-btn>
					<v-btn
						color="primary"
						depressed
						:loading="!!provisioningId"
						:disabled="previewLoading || !previewEmail"
						@click="confirmProvision"
					>
						Aanmaken
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar v-model="snackbar" :color="snackbarColor" top right :timeout="8000">
			{{ snackbarText }}
		</v-snackbar>
	</v-card>
</template>
 
 <script>
import Axios from "axios";
import { API_ROOT } from "../../config";
const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 90000
});

export default {
	name: "employee_cohorts",
	data() {
		return {
			user: JSON.parse(localStorage.getItem("user") || "null"),
			search: "",
			headers: [
				{
					text: "",
					align: "center",
					sortable: false,
					value: "action"
				},
				{ text: "Schoolyear", value: "tbl_sys_schoolyear.name" },
				{ text: "Function", value: "tbl_employee.tbl_sys_function.name" },
				{ text: "Government ID", value: "tbl_employee.government_id" },
				{ text: "Firstname", value: "tbl_employee.firstname" },
				{ text: "Maidenname", value: "tbl_employee.maidenname" },
				{ text: "Lastname", value: "tbl_employee.surname" },
				{ text: "Birthdate", value: "tbl_employee.birthdate" },
				{ text: "Mobiel", value: "tbl_employee.tel_mobile" },
				{ text: "E-mail", value: "tbl_employee.email" },
				{ text: "E-mail OSBOD", value: "tbl_employee.osbod_email" }
			],
			data: [],
			isEmpty: false,
			loading: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 15,
			confirmDialog: false,
			selected: null,
			provisioningId: null,
			previewLoading: false,
			previewEmail: "",
			previewAlreadyExists: false,
			previewError: "",
			snackbar: false,
			snackbarText: "",
			snackbarColor: "success"
		};
	},
	created: function() {
		this.getEmployeeCohort();
	},
	methods: {
		employeeName: function(item) {
			var employee = item && item.tbl_employee;
			if (!employee) {
				return "";
			}
			if (employee.display_name) {
				return employee.display_name;
			}
			return [employee.firstname, employee.surname].filter(Boolean).join(" ");
		},
		osbodEmail: function(item) {
			return item && item.tbl_employee ? String(item.tbl_employee.osbod_email || "").trim() : "";
		},
		hasOsbodEmail: function(item) {
			return !!this.osbodEmail(item);
		},
		personalEmail: function(item) {
			return item && item.tbl_employee ? String(item.tbl_employee.email || "").trim() : "";
		},
		loadPreview: function(item) {
			var self = this;
			this.previewLoading = true;
			this.previewEmail = "";
			this.previewAlreadyExists = false;
			this.previewError = "";
			ax.post("/employee_cohort/preview_osbod_email", {
				employee_cohort_id: item.id,
				user_id: this.user && this.user.id
			})
				.then(function(response) {
					self.previewLoading = false;
					self.previewEmail = (response.data && response.data.osbod_email) || "";
					self.previewAlreadyExists = !!(response.data && response.data.already_exists);
				})
				.catch(function(err) {
					self.previewLoading = false;
					self.previewError =
						(err.response && err.response.data && err.response.data.msg) ||
						"De OSBOD e-mail kon niet worden gecontroleerd.";
				});
		},
		showSnack: function(text, color) {
			this.snackbarText = text;
			this.snackbarColor = color || "success";
			this.snackbar = true;
		},
		handleClick(id) {
			this.$router.push({
				path: "/schooladmin/employee_cohort/update/" + id
			});
		},
		setEmployeeCohort: function() {
			this.$router.push({
				path: "/schooladmin/employee_cohort/new"
			});
		},
		openProvision: function(item) {
			this.selected = item;
			this.confirmDialog = true;
			this.loadPreview(item);
		},
		getEmployeeCohort: function() {
			var self = this;
			this.loading = true;
			ax.get("/employee_cohort/all").then(function(response) {
				self.data = response.data;
				self.loading = false;
			});
		},
		confirmProvision: function() {
			var self = this;
			if (!this.selected) {
				return;
			}
			var cohortId = this.selected.id;
			this.provisioningId = cohortId;
			ax.post("/employee_cohort/provision_osbod_email", {
				employee_cohort_id: cohortId,
				user_id: this.user && this.user.id
			})
				.then(function(response) {
					self.provisioningId = null;
					self.confirmDialog = false;
					var osbod = response.data && response.data.osbod_email;
					if (self.selected && self.selected.tbl_employee && osbod) {
						self.selected.tbl_employee.osbod_email = osbod;
					}
					var mail = response.data && response.data.credentials_mail;
					if (mail && mail.sent) {
						self.showSnack(
							"OSBOD e-mail is aangemaakt. Inloggegevens zijn verstuurd naar " + mail.to + ".",
							"success"
						);
					} else if (response.data && response.data.already_exists) {
						self.showSnack("Bestaand OSBOD-account gekoppeld: " + osbod, "success");
					} else if (osbod) {
						self.showSnack(
							"OSBOD e-mail is aangemaakt (" +
								osbod +
								"), maar de bevestigingsmail is niet verstuurd.",
							"warning"
						);
					} else {
						self.showSnack("OSBOD e-mail is aangemaakt.", "success");
					}
				})
				.catch(function(err) {
					self.provisioningId = null;
					self.showSnack(
						(err.response && err.response.data && err.response.data.msg) ||
							"OSBOD e-mail aanmaken is mislukt.",
						"error"
					);
				});
		}
	}
};
</script>
 
 <!-- Add "slot-scoped" attribute to limit CSS to this component only -->
 <style slot-scoped>
</style>
